var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Intro'),_vm._v(" "),_c('Category'),_vm._v(" "),_c('Jobs',{attrs:{"featuredJobs":_vm.featuredJobs}}),_vm._v(" "),_c('Companies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }